var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-table",class:{ 'list-drag': _vm.canDrag }},[_c('Table',{attrs:{"data":_vm.questions,"row-key":"uuid","fromDetail":_vm.fromDetail},on:{"selection-change":_vm.selectChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }